export default __webpack_public_path__ + "static/media/BodyGame_14.9dd6c1a0.png";